import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'Components/UI/Button';
import Modal from 'Components/UI/Modal';
import { ButtonsContainer, DescriptionContainer } from './styles';

interface IAvisoArquivarObra {
  visible?: boolean;
  nomeObra?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
}

const AvisoArquivarObra: FC<IAvisoArquivarObra> = ({
  visible,
  nomeObra,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation('obras');

  const buttons = (
    <ButtonsContainer>
      <span className="link" onClick={onConfirm}>
        {t('archiveWarning.confirm')}
      </span>
      <Button className="button" type="primary" height={37} onClick={onCancel}>
        {t('archiveWarning.cancel')}
      </Button>
    </ButtonsContainer>
  );

  return (
    <Modal
      title={t('archiveWarning.title')}
      footerButtons={buttons}
      visible={visible}
      width={487}
      onCancel={onCancel}
    >
      <DescriptionContainer>
        <div>{t('archiveWarning.description', { name: nomeObra })}</div>
        <div>{t('archiveWarning.question')}</div>
      </DescriptionContainer>
    </Modal>
  );
};

export default AvisoArquivarObra;
